// extracted by mini-css-extract-plugin
export default {"page__wrapper":"App_page__wrapper__vECP9"};